const badPasswords = [
    'doctor',
    'dentist',
    'office',
    'appointment',
    'health',
    '111111',
    '11111111',
    '112233',
    '121212',
    '123123',
    '123456',
    '1234567',
    '12345678',
    '131313',
    '32323',
    '654321',
    '666666',
    '696969',
    '777777',
    '7777777',
    '8675309',
    '987654',
    'aaaaaa',
    'abc123',
    'abc123',
    'abcdef',
    'abgrtyu',
    'access',
    'access14',
    'action',
    'albert',
    'alexis',
    'amanda',
    'amateur',
    'andrea',
    'andrew',
    'angela',
    'angels',
    'animal',
    'anthony',
    'apollo',
    'apples',
    'arsenal',
    'arthur',
    'asdfgh',
    'asdfgh',
    'ashley',
    'august',
    'austin',
    'badboy',
    'bailey',
    'banana',
    'barney',
    'baseball',
    'batman',
    'beaver',
    'beavis',
    'bigdaddy',
    'bigdog',
    'birdie',
    'bitches',
    'biteme',
    'blazer',
    'blonde',
    'blondes',
    'bond007',
    'bonnie',
    'booboo',
    'booger',
    'boomer',
    'boston',
    'brandon',
    'brandy',
    'braves',
    'brazil',
    'bronco',
    'broncos',
    'bulldog',
    'buster',
    'butter',
    'butthead',
    'calvin',
    'camaro',
    'cameron',
    'canada',
    'captain',
    'carlos',
    'carter',
    'casper',
    'charles',
    'charlie',
    'cheese',
    'chelsea',
    'chester',
    'chicago',
    'chicken',
    'cocacola',
    'coffee',
    'college',
    'compaq',
    'computer',
    'cookie',
    'cooper',
    'corvette',
    'cowboy',
    'cowboys',
    'crystal',
    'dakota',
    'dallas',
    'daniel',
    'danielle',
    'debbie',
    'dennis',
    'diablo',
    'diamond',
    'doctor',
    'doggie',
    'dolphin',
    'dolphins',
    'donald',
    'dragon',
    'dreams',
    'driver',
    'eagle1',
    'eagles',
    'edward',
    'einstein',
    'erotic',
    'extreme',
    'falcon',
    'fender',
    'ferrari',
    'firebird',
    'fishing',
    'florida',
    'flower',
    'flyers',
    'football',
    'forever',
    'freddy',
    'freedom',
    'gandalf',
    'gateway',
    'gators',
    'gemini',
    'george',
    'giants',
    'ginger',
    'golden',
    'golfer',
    'gordon',
    'gregory',
    'guitar',
    'gunner',
    'hammer',
    'hannah',
    'hardcore',
    'harley',
    'heather',
    'helpme',
    'hockey',
    'hooters',
    'horney',
    'hotdog',
    'hunter',
    'hunting',
    'iceman',
    'iloveyou',
    'internet',
    'iwantu',
    'jackie',
    'jackson',
    'jaguar',
    'jasmine',
    'jasper',
    'jennifer',
    'jeremy',
    'jessica',
    'johnny',
    'johnson',
    'jordan',
    'joseph',
    'joshua',
    'junior',
    'justin',
    'killer',
    'knight',
    'ladies',
    'lakers',
    'lauren',
    'leather',
    'legend',
    'letmein',
    'little',
    'london',
    'lovers',
    'maddog',
    'madison',
    'maggie',
    'magnum',
    'marine',
    'marlboro',
    'martin',
    'marvin',
    'master',
    'matrix',
    'matthew',
    'maverick',
    'maxwell',
    'melissa',
    'member',
    'mercedes',
    'merlin',
    'michael',
    'michelle',
    'mickey',
    'midnight',
    'miller',
    'mistress',
    'monica',
    'monkey',
    'monkey',
    'monster',
    'morgan',
    'mother',
    'mountain',
    'muffin',
    'murphy',
    'mustang',
    'naked',
    'nascar',
    'nathan',
    'naughty',
    'ncc1701',
    'newyork',
    'nicholas',
    'nicole',
    'nipple',
    'nipples',
    'oliver',
    'orange',
    'packers',
    'panther',
    'panties',
    'parker',
    'password',
    'patrick',
    'peaches',
    'peanut',
    'pepper',
    'phantom',
    'phoenix',
    'player',
    'please',
    'pookie',
    'porsche',
    'prince',
    'princess',
    'private',
    'purple',
    'pussies',
    'qazwsx',
    'qwerty',
    'qwertyui',
    'rabbit',
    'rachel',
    'racing',
    'raiders',
    'rainbow',
    'ranger',
    'rangers',
    'rebecca',
    'redskins',
    'redsox',
    'redwings',
    'richard',
    'robert',
    'rocket',
    'rosebud',
    'runner',
    'rush2112',
    'russia',
    'samantha',
    'sammy',
    'samson',
    'sandra',
    'saturn',
    'scooby',
    'scooter',
    'scorpio',
    'scorpion',
    'secret',
    'sexsex',
    'shadow',
    'shannon',
    'shaved',
    'sierra',
    'silver',
    'skippy',
    'slayer',
    'smokey',
    'snoopy',
    'soccer',
    'sophie',
    'spanky',
    'sparky',
    'spider',
    'squirt',
    'srinivas',
    'startrek',
    'starwars',
    'steelers',
    'steven',
    'sticky',
    'stupid',
    'success',
    'summer',
    'sunshine',
    'superman',
    'surfer',
    'swimming',
    'sydney',
    'taylor',
    'tennis',
    'teresa',
    'tester',
    'testing',
    'theman',
    'thomas',
    'thunder',
    'thx1138',
    'tiffany',
    'tigers',
    'tigger',
    'tomcat',
    'topgun',
    'toyota',
    'travis',
    'trouble',
    'trustno1',
    'tucker',
    'turtle',
    'twitter',
    'united',
    'vagina',
    'victor',
    'victoria',
    'viking',
    'voodoo',
    'voyager',
    'walter',
    'warrior',
    'welcome',
    'whatever',
    'william',
    'willie',
    'wilson',
    'winner',
    'winston',
    'winter',
    'wizard',
    'xavier',
    'xxxxxx',
    'xxxxxxxx',
    'yamaha',
    'yankee',
    'yankees',
    'yellow',
    'zxcvbn',
    'zxcvbnm',
    'zzzzzz',
    'password1!',
    'password12!',
    'password123!',
    'passwerd1!',
    'passwerd12!',
    'passwerd123!',
    'passw0rd1!',
    'passw0rd12!',
    'passw0rd123!',
    'welcome1!',
    'welcome12!',
    'welcome123!',
    'welc0me!',
    'welc0me1!',
    'welc0me12!',
    'welc0me123!',
    'w3lc0me!',
    'w3lc0me1!',
    'w3lc0me12!',
    'w3lc0me123!',
    'w3lcome!',
    'w3lcome1!',
    'w3lcome12!',
    'w3lcome123!',
    'doctor1!',
    'doctor12!',
    'doctor123!',
    'd0ctor1!',
    'd0ctor12!',
    'd0ctor123!',
    'd0ct0r1!',
    'd0ct0r12!',
    'd0ct0r123!',
    'doct0r1!',
    'doct0r12!',
    'doct0r123!',
    'dentist!',
    'd3ntist!',
    'dentist1!',
    'dentist12!',
    'dentist123!',
    'd3ntist1!',
    'd3ntist12!',
    'd3ntist123!',
    'office1!',
    '0ffice1!',
    'testing1!',
    'testing12!',
    'testing123!',
    'hunter2',
    'CorrectHorseBatteryStaple',
];

export default badPasswords;
